export const WINDOW_SIZE_SM = 575;
export const WINDOW_SIZE_MD = 767;
export const WINDOW_SIZE_LG = 991;
export const WINDOW_SIZE_XL = 1199;
